module.exports = __webpack_public_path__ + "img/beta.4497589c.svg";